
import { ApiWrapper } from "../types/main";
import { apiCall, http } from "./http";
import cfg from "../../config";

export async function updateContacts({
    projectId,
    contactValue
}: {
    projectId: string;
    contactValue: any;
}): Promise<ApiWrapper<any | null>> {
    const url = `deauthNotification/contacts`;
    const res = apiCall<any>(() =>
        http.post(url.toString(), {
            json: { projectId,
                contactValue },
        }),
    );
    return res;
}
export async function verifyContacts({
    projectId,
    contactId
}: {
    projectId: string;
    contactId: string;
}): Promise<ApiWrapper<any | null>> {
    const url = `deauthNotification/contacts/verify`;
    const res = apiCall<any>(() =>
        http.post(url.toString(), {
            json: { projectId,
                contactId },
        }),
    );
    return res;
}

export async function getSettings(projectId: string) {
    const url = `deauthNotification/settings`;
    const res = apiCall<any>(() =>
        http.get(url.toString(), { searchParams: { projectId } }),
    );
    return res;
}

export async function switchSendToReportRecipients({
    projectId,
    sendToReportRecipients
}: {
    projectId: string;
    sendToReportRecipients: boolean;
}): Promise<ApiWrapper<any | null>> {
    const url = `deauthNotification/settings`;
    const res = apiCall<any>(() => http.put(url.toString(), { json: { projectId, sendToReportRecipients } }));
    return res;
}
export async function removeContact({
    projectId,
    id,
}: {
    projectId: string
    id: string,
}): Promise<ApiWrapper<{ id: string }>> {
    const url = `deauthNotification/contacts/${id}`;
    const res = apiCall<any>(() => http.delete(url.toString(), { searchParams: { projectId } }));
    return res;
}
export async function updateContact({
    projectId,
    id,
    contactValue,
}: {
    projectId: string
    id: string,
    contactValue: string,
}): Promise<ApiWrapper<{ id: string }>> {
    const url = `deauthNotification/contacts/${id}`;
    const res = apiCall<any>(() => http.put(url.toString(), { json: { projectId, contactValue } }));
    return res;
}